<template>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" fill-rule="evenodd" viewBox="86.6 263.6 42.2 39.7">
        <title>{{strings['PneuOffer.TTSnowGrip']}}</title>
        <path stroke="#000" stroke-width=".8" stroke-linecap="round" stroke-linejoin="round" d="m87 302.9 7.5-19.3 2.8 3.9 9.5-23.5 5.2 12.2 1.7-4.2 14.7 30.9z" />
        <path d="M111.4 290.4c0-1.5-1.2-2.7-2.6-2.7-1.4 0-2.5 1.2-2.5 2.7s1.1 2.7 2.5 2.7 2.6-1.2 2.6-2.7Z" fill="#000" />
        <path d="m104.1 282.2 9.6 16.4m-7.5-17-.6 3.2-2.8-.8m8.6 14.8.5-3.2 3 .8m-14.6-5.9h17.3m-16.9-2.2 2.2 2.3-2 2.3m15.7-.2-2.2-2.3 2-2.3m-11.3 11 7.6-17m-9.3 15 2.8-.8 1 3.1m7-15-2.8 1-1-3.2" stroke="#000" stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
</template>
<script>
    import { mapState } from 'vuex';

    export default {
        computed: {
            ...mapState([
                'strings'
            ])
        }
    };
</script>